import { useEffect, useContext, useState, useMemo, useRef } from 'react';
import { useGlobalStore, ModalContext } from '../../components/contexts';
import ProcessController from '../../controllers/aia/ProcessController';
import ValidateService from '../../services/ValidateService';
import { useNavigate } from 'react-router-dom';

import SelectEnt from '../../components/selectComponents/SelectEnt';
import GbitTable from '../../components/tableComponents/GbitTable';

const Process = () => {
  useEffect(() => {
    document.title = '공정관리';
  }, []);

  const { store, updateStore } = useGlobalStore();
  const { modalService } = useContext(ModalContext);
  const validateService = new ValidateService(modalService);

  const tableRef = useRef(null);
  const [valueObj, setValueObj] = useState({
    entSn: store.entSn,
    pageSize: 10,
  });
  const [searchParam, setSearchParam] = useState({
    entSn: store.entSn,
    pageSize: 10,
  });
  const [dataList, setDataList] = useState([]);

  const navigate = useNavigate();

  const controller = useMemo(() => {
    return new ProcessController(
      store,
      modalService,
      validateService,
      [tableRef],
      [searchParam, setSearchParam],
      {
        valueObj,
        setValueObj,
        dataList,
        setDataList,
      },
      navigate // navigate 함수를 전달
    );
  }, [store, modalService, validateService]);

  useEffect(() => {
    controller.init();
  }, []);

  useEffect(() => {
    controller.getTask();
  }, [searchParam]);

  const handleChange = (field, value) => {
    setValueObj(prev => {
      let newValueObj = { ...prev, [field]: value };

      if (field === 'tpbizTypeId') {
        controller.loadTaskOptions(value);
        newValueObj = {
          ...newValueObj,
          comCd: '',
          comCdNm: '',
          comCdNm2: '',
          isTaskNameEditable: false,
          taskOptions: [],
        };
      } else if (field === 'comCd') {
        const isDirectInput = value === 'all';

        const selectedTask = prev.taskOptions.find(
          option => option.comCd === value
        );

        newValueObj = {
          ...newValueObj,
          comCdNm: isDirectInput ? '' : selectedTask?.comCdNm || '',
          comCdNm2: '',
          isTaskNameEditable: isDirectInput,
          taskNm: isDirectInput ? prev.comCdNm2 : selectedTask?.comCdNm || '',
          taskExpln: '',
        };
      } else if (field === 'comCdNm2') {
        newValueObj = { ...newValueObj, taskNm: value };
      }

      return newValueObj;
    });
  };

  return (
    <>
      <div className="page-title-wrap" data-type="responsive">
        <h2 className="h-tit">공정관리</h2>
      </div>
      <div className="tbl-wrap">
        <p className="tbl-msg">
          <em className="star-require">*</em> 표시는 필수 입력 사항입니다.
        </p>
        <table className="tbl data row">
          <colgroup></colgroup>
          <tbody>
            <tr>
              <th scope="row">
                공정<em className="star-require">*</em>
              </th>
              <td>
                <div className="input-group">
                  {store.authrtId === 'ADMIN' && (
                    <SelectEnt
                      model="entSn"
                      valueObj={searchParam}
                      valueChange={(model, value) => {
                        controller.searchParamChange(model, value);
                      }}
                    />
                  )}
                  <label
                    className="hidden-label"
                    htmlFor="tpbizTypeId"
                    id="tpbizTypeIdLbl"
                  >
                    업종
                  </label>
                  <select
                    id="tpbizTypeId"
                    className="form-select md"
                    value={valueObj?.tpbizTypeId || ''}
                    onChange={e => handleChange('tpbizTypeId', e.target.value)}
                    aria-labelledby="tpbizTypeIdLbl"
                  >
                    <option value="" disabled>
                      업종 선택
                    </option>
                    {valueObj?.tpbizOptions?.map((option, index) => (
                      <option key={index} value={option.tpbizTypeId}>
                        {option.tpbizTypeNm}
                      </option>
                    ))}
                  </select>
                  <label
                    className="hidden-label"
                    htmlFor="taskId"
                    id="taskIdLbl"
                  >
                    공정
                  </label>
                  <select
                    id="taskId"
                    className="form-select md"
                    value={valueObj?.comCd || ''}
                    onChange={e => handleChange('comCd', e.target.value)}
                    aria-labelledby="taskIdLbl"
                    disabled={
                      valueObj?.tpbizTypeId === '' ||
                      valueObj.tpbizTypeId === undefined ||
                      valueObj.tpbizTypeId === null
                    }
                  >
                    <option value="" disabled>
                      공정 선택
                    </option>
                    <option value="all">직접 입력</option>
                    {valueObj?.taskOptions?.map((option, index) => (
                      <option key={index} value={option.comCd}>
                        {option.comCdNm}
                      </option>
                    ))}
                  </select>
                  <label
                    className="hidden-label"
                    htmlFor="taskNm"
                    id="taskNmLbl"
                  >
                    공정명
                  </label>
                  <input
                    id="taskNm"
                    type="text"
                    className="form-control md"
                    placeholder="공정명 입력"
                    value={
                      valueObj?.isTaskNameEditable
                        ? valueObj?.comCdNm2 || ''
                        : valueObj?.taskNm || ''
                    }
                    onChange={e => handleChange('comCdNm2', e.target.value)}
                    readOnly={!valueObj?.isTaskNameEditable}
                    maxLength={10}
                    aria-labelledby="taskNmLbl"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">
                공정 상세내용<em className="star-require">*</em>
              </th>
              <td>
                <div className="input-group">
                  <label className="hidden-label" htmlFor="taskExpln">
                    라벨
                  </label>
                  <input
                    id="taskExpln"
                    type="text"
                    className="form-control md"
                    placeholder="상세내용 입력"
                    value={valueObj?.taskExpln || ''}
                    onChange={e => handleChange('taskExpln', e.target.value)}
                    maxLength={16}
                    aria-labelledby="taskExpln"
                  />
                  <button
                    type=" button"
                    className="btn md primary"
                    onClick={() => {
                      controller.fnSave();
                    }}
                  >
                    저장
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="tbl-wrap">
        <GbitTable
          ref={tableRef}
          tableName="taskInfo"
          headerList={controller.headerList}
          bodyList={dataList}
          onHeaderClick={controller.tableHeaderClick.bind(controller)}
          onCellClick={controller.tableCellClick.bind(controller)}
          pageNow={searchParam?.currentPage}
          pageSize={searchParam?.pageSize}
          pageChange={value =>
            controller.searchParamChange('currentPage', value)
          }
        />
      </div>
      <div className="page-btn-wrap">
        <button
          type="button"
          className="btn xlg tertiary"
          onClick={() => controller.fnDelete()}
        >
          선택 삭제
        </button>
      </div>
    </>
  );
};

export default Process;
